import React, { useState, useEffect } from "react";
import Layout from "../../../components/Layout";
import {
  List,
  ListHeader,
  ListHeaderItem,
  ListHeaderItemDropdown,
  ListBody,
  ListBodyCell,
  ListBodyItem,
} from "../../../components/_widgets/WidgetsList";
import api from "../../../config/api";
import { formatDate, getAllClientReservationsCompleted, getUserAll } from "../../../config/utils";
import SearchInput from "../../../components/inputs/SearchInput";
require("dotenv").config();

function ReserveCompleted() {
  const [clientReservations, setClientReservations] = useState([]);
  const [allUser, setAllUser] = useState([]);

  // Filter
  const [selectedUser, setSelectedUser] = useState("");
  const [nameFilter, setNameFilter] = useState("");

  // Pagination
  const [qtLimitItem, setQtLimitItem] = useState(10);
  const [pageItemsList, setPageItemsList] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    getClientReservation(pageItemsList, qtLimitItem, selectedUser, nameFilter);
    getAllClientReservations();
    getClients();
  }, []);

  const getClientReservation = async (page, limit, selectedUser, name) => {
    let response = await api.get(
      `/clientReservation/complete?page=${page}&limit=${limit}&paginate=true&selectedUser=${selectedUser}&name=${name}`
    );
    setClientReservations(response.data.docs);
    console.log("response.data", response.data);
  };

  // Filter
  const getClients = async () => {
    let response = await getUserAll();
    setAllUser(response.list);
  };

  const handleSelectedName = (value) => {
    setSelectedUser(value);
    getClientReservation(pageItemsList, qtLimitItem, value, nameFilter);
  };

  const handleInputName = (value) => {
    setNameFilter(value);
    getClientReservation(pageItemsList, qtLimitItem, selectedUser, value);
  };

  // Pagination
  const getAllClientReservations = async () => {
    let response = await getAllClientReservationsCompleted();
    setTotalItems(response.total);
  };

  const setLimitList = (value) => {
    setQtLimitItem(value);
    setPageItemsList(1);
    getClientReservation(1, value, selectedUser, nameFilter);
  };

  const changePage = (event) => {
    setPageItemsList(event.target.id);
    getClientReservation(event.target.id, qtLimitItem, selectedUser, nameFilter);
  };

  const prevButton = () => {
    if (pageItemsList !== 1) {
      setPageItemsList(pageItemsList - 1);
      getClientReservation(pageItemsList - 1, qtLimitItem, selectedUser, nameFilter);
    }
  };

  const nextButton = () => {
    let qtPages = Math.ceil(totalItems / qtLimitItem);
    if (pageItemsList.toString() !== qtPages.toString()) {
      setPageItemsList(pageItemsList + 1);
      getClientReservation(pageItemsList + 1, qtLimitItem, selectedUser, nameFilter);
    }
  };

  return (
    <>
      <Layout defaultMenu={3} title={"Reservas concluídas"} link={"#"}>
        <div className="store container-fluid px-lg-1 pt-1">
          <div className="d-flex flex-column flex-lg-row">
            <SearchInput value={nameFilter} onChange={handleInputName} className="mb-3" />

            {/* <BlackWhiteButton
              className="mb-3"
              size={12}
              sizeLg={9}
              text="Exportar planilha"
            /> */}
          </div>
          <div className="d-flex flex-column flex-lg-row pb-4">
            <List
              section={"reservas"}
              onChange={(e) => setLimitList(e.target.value)}
              limit={qtLimitItem}
              totalItem={totalItems}
              prevButton={() => prevButton()}
              nextButton={() => nextButton()}
              page={pageItemsList}
              changePage={(e) => changePage(e)}
            >
              <ListHeader>
                <ListHeaderItem sizeLg={3} title={"Nome"}>
                  <ListHeaderItemDropdown>
                    <li
                      className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                      style={{ borderBottom: "1px solid #D9D9D9" }}
                    >
                      <div className="input-group input-search">
                        <input
                          type="text"
                          style={{ width: "173px" }}
                          className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                          placeholder={"Procure por estabelecimento"}
                        />
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search " style={{ color: "#000000" }}></i>
                        </span>
                      </div>
                    </li>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      <div key={"all"} onClick={() => handleSelectedName("")} className="dropdown-item">
                        <span>Todos</span>
                      </div>
                      {allUser.map((item, index) => (
                        <div key={index} onClick={() => handleSelectedName(item._id)} className="dropdown-item">
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                <ListHeaderItem sizeLg={3} title={"E-mail"}>
                  <ListHeaderItemDropdown>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      <div key={"allEmail"} onClick={() => handleSelectedName("")} className="dropdown-item">
                        <span>Todos</span>
                      </div>
                      {allUser.map((item, index) => (
                        <div key={index} onClick={() => handleSelectedName(item._id)} className="dropdown-item">
                          <span>{item.email}</span>
                        </div>
                      ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                <ListHeaderItem sizeLg={3} title={"Telefone"} />
                <ListHeaderItem sizeLg={3} title={"Data da reserva"} />
              </ListHeader>
              <ListBody>
                {clientReservations.map((item, index) => (
                  <ListBodyCell key={index} className={`${index % 2 !== 0 ? "bg-cl-cultured" : ""}`}>
                    <ListBodyItem sizeLg={3} description={"Nome"} title={item.user.name} />
                    <ListBodyItem sizeLg={3} description="E-mail" title={item.user.email} />
                    <ListBodyItem sizeLg={3} description={"Telefone"} title={item.user.phone} />
                    <ListBodyItem sizeLg={2} description={"Data da reserva"} title={formatDate(item.createdAt)} />
                  </ListBodyCell>
                ))}
              </ListBody>
            </List>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default ReserveCompleted;
